import { BuildVersion, IEnvironment } from './environment.interface';
import buildVersion from '@env/buildVersion';

const apiUrl = 'https://production.api';

export const environment: IEnvironment = {
  apiUrl,
  modules: [],
  production: false,
  routes: [],
  version: buildVersion as BuildVersion,
  wccLibraryUrl: 'https://mncregtraining.blob.core.windows.net/documentlibrary/hh/wcc/library',
};
